// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"building-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M21 21V9H3V21H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M8 9V4.4L12 2L16 4.4V9H8Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"fill2","fill":"transparent","d":"M15 14H9V21H15V14Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M12 5.99805H12.0039V6.00195H12V5.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M15 14H9V21H15V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 5L12 2L17 5M8 4.9V9M16 4.9V9M21 9V21H3V9H21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-building-2')
export default class Building2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-2',
    }
  }
}
